import isHS from "@/vue/planning/logic/hs"

export const getPrestCrossedPrice = (prest, isHaveQuoteResponse) => {
	if (!prest.maxPromo) return null
	if (!prest.crossedPrice || prest.crossedPrice === 0)
		throw new Error("crossedPrice must exist and be a positive number")

	if (prest.maxPromo < 5) return null

	if (isHS(prest) || isHaveQuoteResponse) {
		return prest.crossedPrice
	} else {
		return prest.crossedPrice * prest.maxCapacity
	}
}

const priceWithoutFee = (prest) => {
	if (!prest.pricePerLogementWithoutFee) return null
	if (prest.pricePerLogementWithoutFee <= 0)
		throw new Error("pricePerLogementWithoutFee must be a positive number")
	return prest.pricePerLogementWithoutFee
}

const priceWithFee = (prest) => {
	if (!prest.pricePerLogement) return null
	if (prest.pricePerLogement <= 0)
		throw new Error("pricePerLogement must be a positive number")
	return prest.pricePerLogement
}

export const getPrestTotalPrice = (prest) => {
	const prestPriceWithFee = priceWithFee(prest)
	const prestPriceWithoutFee = priceWithoutFee(prest)
	return !isHS(prest) && prestPriceWithoutFee
		? prestPriceWithoutFee
		: prestPriceWithFee
}

export const getPrestPerPrice = (prest, participantsNum) => {
	const prestPriceWithFee = priceWithFee(prest)
	const prestPriceWithoutFee = priceWithoutFee(prest)
	return !isHS(prest) && prestPriceWithoutFee
		? parseInt(prestPriceWithoutFee / participantsNum)
		: parseInt(prestPriceWithFee / participantsNum)
}

export const getPrestMaxPromo = (prest) => {
	if (!prest.maxPromo) return null
	return prest.maxPromo >= 5 ? prest.maxPromo : null
}
